import styles from './FJFaceSwapLeftRight.module.less';
import FJDisplayHeaderContainer from '../../FJMainPreview/FJDisplayHeader/FJDisplayHeaderContainer';
import FJCreationPanelContainer from '../../FJMainPreview/FJCreationPanel/FJCreationPanelContainer';
import FJHistoryPanelContainer from '../../FJMainPreview/FJHistoryPanel/FJHistoryPanelContainer';
import classNames from 'classnames';

const FJFaceSwapLeftRight = () => {
    return (
        <div className={classNames(styles.app_right)}>
            <FJDisplayHeaderContainer isShowProgress={false} />

            <FJCreationPanelContainer activeHeaderTabIndex={0} />

            <FJHistoryPanelContainer activeHeaderTabIndex={1} />
        </div>
    );
};

export default FJFaceSwapLeftRight;
